import { render, staticRenderFns } from "./HeaderRoiWidget.vue?vue&type=template&id=f1ecbcf6&scoped=true&lang=html&"
import script from "./HeaderRoiWidget.vue?vue&type=script&lang=js&"
export * from "./HeaderRoiWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ecbcf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
